app.directive('ngFileModel', ['$parse', function ($parse) {
    return {        
        restrict: 'A',
        link: function (scope, element, attrs) {                        
            var model = $parse(attrs.ngFileModel);            
            var isMultiple = attrs.multiple;
            var modelSetter = model.assign;                        
            
            element.bind('change', function () {                                                
                var values = [];
                angular.forEach(element[0].files, function (item) {                    
                    var value = {                       
                        name: item.name,                                               
                        url: URL.createObjectURL(item),                        
                        file: item
                    };
                    values.push(value);                                            
                });
                scope.$apply(function () {
                    if (isMultiple) {
                        modelSetter(scope, values);
                    } else {
                        modelSetter(scope, values[0]);
                    }
                });
            });
        }
    };
}]);

app.directive('fileModel', ['$parse', function ($parse) {
    return {
        restrict: 'A',
        link: function(scope, element, attrs) {
            var model = $parse(attrs.fileModel);
            var modelSetter = model.assign;
            
            element.bind('change', function(){
                scope.$apply(function(){             
                    modelSetter(scope, element[0].files[0]);                    
                });
            });
        }
    };
}]);